<script setup>
import { ref, inject } from "vue";
import { __, getFormValuesFromLocalStorage, setFormValues } from '@/utils';
import Modal from "@components/modal.vue";
import Hint from "@components/hint.vue";
import IconSim from "../../icons/icon-sim.vue";

const { selectedNumber, setProcessStep } = inject('activationProcess');

const localStorageValues = getFormValuesFromLocalStorage();
const phoneNumbers = ref(localStorageValues.phoneNumbers);
const isActive = ref(false);
const isDisable = ref(true);
const remainingEsimNumbers = ref([]);

const checkEsimNumbers = () => {
    let hasInactiveEsim = false;
    phoneNumbers.value?.forEach(entry => {
        if (!entry.active && entry.sim_type == 'esim') {
            hasInactiveEsim = true;
        }
    });
    return !hasInactiveEsim;
}


const completeActivation = () => {
    phoneNumbers.value?.forEach(entry => {
        if(entry.number == selectedNumber.value.number){
            entry.active = true;
            setFormValues(localStorageValues)
        }
    });
    
    if(checkEsimNumbers()){
        setProcessStep(4)
    }else{
        setProcessStep(1)
    }
}

phoneNumbers.value?.forEach(entry => {
    if(entry.sim_type === 'esim' && !entry.active){
        remainingEsimNumbers.value.push(entry)
    }
});

const activateNumber = () => {
    isActive.value = false
}
</script>
<template>
    <button class="btn-circle-icon" type="button" @click="setProcessStep(2)">
        <span>{{ __('return') }}</span>
        <i class="ico ico--arrow-right"></i>
    </button>
    <div class="align-center">
        <div class="step-heading mb24">
            <div class="step-heading__icon">
                <IconSim />
            </div>
            <h3 class="gradient">
                <strong>{{ __('The SIM card was successfully activated and processed.') }}</strong>
            </h3>
        </div>
        <h4><strong>{{ __('The mobilization process is scheduled to end Thursday at 1 pm - 2:15 pm') }}</strong></h4>
        <h5>{{ __('When there is no reception on your device,') }}</h5>
        <p class="fz16">
            {{ __('The XPhone SIM card must be inserted into the device, and restarted') }}
        </p>
        <p><strong>{{ __('Still struggling? Use our guides') }}</strong></p>
        <div class="guide-cta mb13">
            <div class="guide-cta__item">
                <Hint :hint="{title: 'lorem','description': 'lorem'}" />
                <button type="button">
                    {{ __('Android Guide') }}
                </button>
            </div>
            <div class="guide-cta__item">
                <Hint :hint="{title: 'lorem','description': 'lorem'}" />
                <button type="button">
                    {{ __('IOS Guide') }}
                </button>
            </div>
        </div>
        <p class="fz13 mb32">
            {{ __('For your attention, the move will be made within 40 minutes on Sunday-Thursday, between the hours of 08:00-21:00, and on Friday between the hours of 08:00-12:00. Mobility requests received outside business hours will be processed the next business day starting at 08:00 am') }}<br />
            <strong>{{ __('Keep in mind that there are situations in which the mobility process may fail!') }}</strong>
        </p>
        <button class="btn btn--arrows" type="button" @click="completeActivation">
            {{ __('Click to activate another SIM') }}
        </button><!-- /.btn -->
    </div>


    <Modal :isActive="isActive" @close="isActive = false">
        <template #head>
            <p>
                {{ __('Please note, line ') }}{{ selectedNumber.number }} {{ __(' is currently running.') }}
            </p>
        </template>
        <template #body>
            <p>
                {{ __('The national mobility system operates Sunday-Thursday 08:00-21:00 hours. On Friday and Cristmas Eve from 08:00-13:00. You can come back within the hours of operation and carry out the process.') }}
            </p>
            <p>{{ __('Select another subscription to activate.') }}</p>
            <div class="number-boxes" v-if="remainingEsimNumbers?.length">
                <div v-for="number in remainingEsimNumbers" :key="number.number">
                    <button type="button" class="btn-shadow" v-if="!number.active" @click="activateNumber(number)">
                        {{ number.number }}
                    </button>
                </div>
            </div>
        </template>
        <template #foot>
            <button class="btn" type="button" @click="activateNumber" :disabled="isDisable">
                {{ __('Continue') }}
            </button><!-- /.btn -->
        </template>
    </Modal>
</template>